import {
  Mutation,
  Action,
  VuexModule,
  getModule,
  Module,
} from "vuex-module-decorators";
import store from "@/store";
import { Location } from "@/store/modules/Locations/LocationEntitiy";
import LocationFactory from "@/store/modules/Locations/LocationFactory";
import { LocationRepository } from "@/store/modules/Locations/repository/LocationRepository";
import DeepCloner from "@/store/common/DeepCloner";
import { ResultStatus } from "@/store/common/ResultStatus";

@Module({
  name: "LocationsStore",
  dynamic: true,
  store: store,
  namespaced: true,
})
class LocationsStore extends VuexModule {
  // states
  private _locations: Location[] = [];

  // getters
  get locations(): Location[] {
    return this._locations;
  }

  @Mutation
  private setLocations(locations: Location[]) {
    this._locations = DeepCloner.copyJson(locations);
  }

  @Action
  public startRealtimeUpdate() {
    LocationRepository.watch((snapshot) => {
      const locations = LocationFactory.makeByFirestoreSnapshot(snapshot);

      // 24時間経過したものを削除
      const now = new Date();
      const invalidThreshold = 24 * 60 * 60 * 1000;
      const invalidLocations = locations.filter(
        (v) => now.getTime() - v.date.getTime() > invalidThreshold
      );
      if (invalidLocations.length > 0) {
        invalidLocations.forEach((v) => this.delete(v.id));
        return;
      }

      this.setLocations(locations);
    });
  }

  @Action
  public endRealtimeUpdate() {
    LocationRepository.unWatch();
  }

  @Action
  public add(param: Location) {
    return new Promise<ResultStatus>(async (resolve) => {
      const addResult = await LocationRepository.add(param);
      resolve(addResult);
    });
  }

  @Action
  public async delete(id: string) {
    return new Promise<ResultStatus>(async (resolve) => {
      const deleteResult = await LocationRepository.delete(id);
      resolve(deleteResult);
    });
  }
}

export default getModule(LocationsStore);
